import {Component, OnInit, AfterViewInit, OnDestroy, Input} from '@angular/core';
import {AppHeartBeatService} from './app-heart-beat.service';
import {CommonService} from '../common.service';

@Component({
  selector: 'app-heart-beat',
  templateUrl: './app-heart-beat.component.html',
  styleUrls: []
})

export class AppHeartBeatComponent implements OnInit , AfterViewInit, OnDestroy{

  @Input() browserPlatformLocation: string; //browserPlatformLocation

  timer: any; //定时器对象
  heartBeatData: any = {}; //心跳传输对象
  duration: any; //心跳间隔
  geolocation: any; //定位对象
  url: string; //请求地址
  learningPathMetaId: any;
  userId: any;
  //过滤协议列表
  filterHttpProtocolList: any=[
    'https:',
    'wss:',
    'file:',
    'chrome-extension:'
  ];

  heartBeatSourceData: any = {};
  isCamp : boolean = false;
  constructor(
    private commonService: CommonService,
    private heartBeatService: AppHeartBeatService,
  ) { }
  ngOnInit() {
    this.isCamp = !!this.commonService.getStorage('skuId');
    this.url = this.heartBeatService.getEnvironmentsUrl(this.browserPlatformLocation['host']);
    this.heartBeatOnInit();
  }

  ngAfterViewInit(){

  }

  ngOnDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  // 心跳定时器逻辑
  // 获取心跳间隔
  // 先获取定位信息（过滤geolocationAPI拦截的不安全协议）
  // 设置参数
  // 根据心跳间隔保存心跳数据
  heartBeatOnInit() {
    const appId = this.heartBeatService.getEnvironmentsAppId(this.browserPlatformLocation['host']);
    this.heartBeatData.appId = appId;
    this.heartBeatService.getHeartBeatDuration(this.browserPlatformLocation['host'],appId, this.url).then(result => {
      this.duration = result.appTimeInterval;
    }).then(() => {
      // this.heartBeatSourceData['geolocation'] = this.geolocation;
      this.timer = setInterval(() => {
        // this.learningPathMetaId = $('#learningPathMetaIdContainer').val();
        // this.userId = $('#userIdContainer').val();
        // this.learningPathMetaId = $('#learningPathMetaIdContainer').val();
        // this.userId = $('#userIdContainer').val();
        this.learningPathMetaId = this.commonService.getStorage("learningPathMetaId");
        if(this.isCamp){
          if(this.commonService.getStorage("learningPathMetasId") && Number(this.commonService.getStorage("learningPathMetasId")) !== 414 ){
            //互联网day1心跳learningPathMetaId先不改变
            this.learningPathMetaId = Number(this.commonService.getStorage("learningPathMetasId"));
          }
        }

        this.userId = $('#userIdContainer').val() ? $('#userIdContainer').val() : this.commonService.getStorage('userId') ? this.commonService.getStorage('userId') : '';
        this.heartBeatSourceData['userId'] = this.userId;
        this.heartBeatSourceData['learningPathMetaId'] = this.learningPathMetaId;
        this.heartBeatSourceData['pathname'] = this.browserPlatformLocation['pathname'];
        this.heartBeatSourceData['moduleId'] = this.commonService.getStorage('moduleId') ? Number(this.commonService.getStorage('moduleId')): null;
        this.heartBeatService.setHeartBeatValue(this.heartBeatData, this.heartBeatSourceData);
        this.heartBeatService.saveHeartBeatValue(this.browserPlatformLocation['host'],this.heartBeatData, this.url).subscribe();
      }, this.duration * 1000);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/app-heart-beat/app-heart-beat.component.ts